import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { useLocation } from "react-router-dom"
import CostRefundView from "./views/CostRefundView"
import { useGetCostRefundDetailQuery, useUpdateCostRefundStatusMutation } from "./api/costRefundApiSlice"


const CostRefundDetail = ({
    administrable = false
}) => {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    let location = useLocation()

    let refundGuid = location.state.guid

    // API
    const {
        data: response,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetCostRefundDetailQuery(refundGuid)

    // API
    const [updateCostRefund, updateCostRefundResult] = useUpdateCostRefundStatusMutation()

    const handleAccept = () => {
        updateCostRefund({
            guid: response.guid,
            newStatus: "ACCEPTED"
        })
    }

    const handleDelete = () => {
        updateCostRefund({
            guid: response.guid,
            newStatus: "DELETED"
        })
    }


    let content = <>
        {
            isSuccess &&
            <div className="row">
                <div className="col-md-8">
                    <CostRefundView
                        refund={response}
                        administrable={administrable}
                        onAccept={handleAccept}
                        onDelete={handleDelete}
                    />
                </div>
                <div className="col-md-4">

                </div>
            </div>
        }

    </>


    return <PageLayout
        pageTitle={t("absenceReport:menu.cost_refund_detail")}
        bodyContent={content}
        onPageRefresh={refetch}
        isError={isError}
        errorMsg={error}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}

    />
}

export default CostRefundDetail